import {
  TableCell,
  TableHead as MuiTableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  Box,
} from '@mui/material';

import { HeadCell } from 'types';

export type TableHeadPropsType = {
  headCells: Array<HeadCell> | any;

  /** Optional props */
  numSelected?: number;
  orderDirection?: 'desc' | 'asc';
  orderBy?: string;
  rowCount?: number;
  onSelectAllClick?: (e: any) => void;
  onRequestSort?: (e: any, property: string) => void;
  tableTitle?: string;
  showCheckBox?: boolean;
  indeterminate?: boolean;
  checked?: boolean;
};

const _noop = () => {};

const TableHead: React.FC<TableHeadPropsType> = (props) => {
  const { orderDirection, orderBy, onRequestSort, headCells } = props;
  const createSortHandler = (property: string) => (event: any) => {
    if (onRequestSort) {
      onRequestSort(event, property);
    }
  };

  return (
    <MuiTableHead>
      <TableRow
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'dark' ? 'rgba(30, 41, 59, 0.6)' : 'rgba(241, 245, 249, 0.8)',
          borderBottom: (theme) =>
            theme.palette.mode === 'dark'
              ? '2px solid rgba(148, 163, 184, 0.2)'
              : '2px solid rgba(203, 213, 225, 0.6)',
        }}
      >
        {headCells.map((headCell: HeadCell) => (
          <Tooltip
            placement={headCell.tooltipPlacement || 'bottom'}
            key={headCell.id}
            title={headCell.tooltip || ''}
          >
            <TableCell
              key={headCell.id}
              align={headCell?.align || 'left'}
              padding={headCell?.disablePadding ? 'none' : 'normal'}
              sx={{
                whiteSpace: 'nowrap',
                backgroundColor: 'transparent',
                fontWeight: 600,
                fontSize: '0.875rem',
                color: (theme) =>
                  theme.palette.mode === 'dark' ? 'rgba(226, 232, 240, 1)' : 'rgba(30, 41, 59, 1)',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                py: 2.5,
                ...headCell.style,
              }}
              className="header-cell"
              sortDirection={orderBy === headCell.id ? orderDirection : false}
            >
              <Box
                sx={{
                  display: 'flex',
                }}
              >
                {headCell.disableSort || headCell.id === 'collapse' ? (
                  <span>{headCell.label}</span>
                ) : (
                  <TableSortLabel
                    style={headCell.style}
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? orderDirection : 'asc'}
                    onClick={createSortHandler(headCell.id)}
                    sx={{
                      '& .MuiTableSortLabel-icon': {
                        color: (theme) =>
                          theme.palette.mode === 'dark'
                            ? 'rgba(165, 180, 252, 0.8) !important'
                            : 'rgba(99, 102, 241, 0.8) !important',
                      },
                    }}
                  >
                    <span>{headCell.label}</span>
                  </TableSortLabel>
                )}
              </Box>
            </TableCell>
          </Tooltip>
        ))}
      </TableRow>
    </MuiTableHead>
  );
};

export default TableHead;
